import { render, staticRenderFns } from "./PageUpdate.vue?vue&type=template&id=32011777"
import script from "./PageUpdate.vue?vue&type=script&lang=ts"
export * from "./PageUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports